import React from 'react';

const BilingualText = ({ en, es, className = "", inverse = false }) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <span className={`font-bold ${inverse ? 'text-mx-gold' : 'text-inherit'} uppercase tracking-wide`}>
        {en}
      </span>
      <span className={`text-sm italic font-serif ${inverse ? 'text-gray-300' : 'text-gray-500'} opacity-90`}>
        {es}
      </span>
    </div>
  );
};

export default BilingualText;